// WHOSE end-user identity is authoritative for a partner's shoppers — the
// fourth partner-shaped vocabulary, and a different axis from the three in
// partner-products.ts. Those answer "what may this partner transact?"; this
// answers "who does the person clicking Book prove they are to?".
//
//   drivecars  We authenticate the shopper. The original and still the
//              default: the partner embeds our widget, the shopper signs in
//              with DriveCars, and the SDK mints a session from that.
//
//   partner    The partner authenticates their own users and hands us THEIR
//              token, which we introspect at partners.auth_introspection_url.
//              For a partner who already has logged-in users, asking those
//              users to sign in again inside the partner's own site is the
//              thing that kills the embed.
//
// It lives in @drivecars/shared rather than next to PartnerRow because both
// the admin schema and the service layer need it, and a constant imported
// from the service module cannot survive a suite that vi.mock()s that module
// wholesale — which is exactly how the first version of this broke.
//
// Mirrors 0219's partners_auth_provider_valid CHECK. Change one, change both.

export const PARTNER_AUTH_PROVIDERS = ['drivecars', 'partner'] as const;

export type PartnerAuthProvider = (typeof PARTNER_AUTH_PROVIDERS)[number];

export function isPartnerAuthProvider(s: string): s is PartnerAuthProvider {
  return (PARTNER_AUTH_PROVIDERS as readonly string[]).includes(s);
}
